import { call, put, takeLatest } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import swal from 'sweetalert';
import api from 'services/api';
import vouchersAPI from 'services/vouchers'

import { Creators as VouchersActions, Types as VouchersTypes } from 'store/ducks/vouchers';

function* getVoucherRequest(action) {
  try {
    const { id } = action.payload;
    const url = `experience/vouchers/${id}`;
    const response = yield call(vouchersAPI.get, url);

    yield put(VouchersActions.getVoucherSuccess(response.data));
  } catch (error) {
    yield put(VouchersActions.getVoucherFailure());
  }
}

function* getVouchersRequest(action) {
  try {
    const { page } = action.payload;
    const url = `experience/vouchers/money?page=${page}&per=25`;
    const response = yield call(vouchersAPI.get, url);

    yield put(VouchersActions.getVouchersSuccess(response.data));
  } catch (error) {
    yield put(VouchersActions.getVouchersFailure());
  }
}

function* createVoucherRequest(action) {
  try {
    const { data } = action.payload;
    const url = 'experience/vouchers/money';
    yield call(vouchersAPI.post, url, data)

    yield put(push('/points/vouchers'));
    yield call(swal, 'Adicionado', 'Voucher adicionado com sucesso!', 'success');
    yield put(VouchersActions.createVoucherSuccess());
  } catch (error) {
    yield call(swal, 'Falha ao atualizar', 'Não foi possível criar o voucher.', 'error');
    yield put(VouchersActions.createVoucherFailure());
  }
}

function* updateVoucherRequest(action) {
  try {
    const { id, data } = action.payload;
    const url = `experience/vouchers/money/${id}`;
    yield call(vouchersAPI.put, url, data);

    yield put(push('/points/vouchers'));
    yield call(swal, 'Atualizado', 'Voucher atualizado com sucesso!', 'success');
    yield put(VouchersActions.updateVoucherSuccess());
  } catch (error) {
    yield call(swal, 'Falha ao atualizar', 'Não foi possível atualizar o voucher.', 'error');
    yield put(VouchersActions.updateVoucherFailure());
  }
}

function* getVouchersPlansRequest(action) {
  try {
    const url = "experience/v2/plans?page=1&per=100&gives_points_value=true";
    const response = yield call(api.get, url);

    yield put(VouchersActions.getVouchersPlansSuccess(response.data));
  } catch (error) {
    yield put(VouchersActions.getVouchersPlansFailure());
  }
}

export default function* sagaVouchers() {
  yield takeLatest(VouchersTypes.GET_REQUEST, getVoucherRequest);
  yield takeLatest(VouchersTypes.GET_LIST_REQUEST, getVouchersRequest);
  yield takeLatest(VouchersTypes.CREATE_REQUEST, createVoucherRequest);
  yield takeLatest(VouchersTypes.UPDATE_REQUEST, updateVoucherRequest);
  yield takeLatest(VouchersTypes.GET_PLANS_REQUEST, getVouchersPlansRequest);
}
